module.exports = __webpack_public_path__ + "img/uchechukwu-azubuko.c03d4196.png";